export default __webpack_public_path__ + "static/trees-a9489292ba181d9f8dc3ebb89890f576.png";